module.exports = __webpack_public_path__ + "img/Intro.05dd14d2.jpg";